import React, { SyntheticEvent, ChangeEvent } from 'react';
import styled from 'styled-components';
import RegisteredEmailDomainInputContainer from '../components/registeredEmailDomainInputContainer';
import { Label } from '../../components/forms/Label';
import { Input } from '../../components/forms/Input';
import TextArea from '../../components/forms/TextArea';
import type { StyledComponentWithChildren } from '../../types/styledComponent';
import { type Message } from '../components/styledComponent/MessageDisplay';

const InputRowWrapper: StyledComponentWithChildren = styled.div`
  display: flex;
  padding: 5px 5px;
`;

const InputLabelWrapper = styled.div`
  display: flex;
  flex: 0 0 160px;
`;

const InputFieldWrapper = styled.div<{ width: string; height?: string }>`
  display: flex;
  flex: 0 0 ${(props: { width: any; }) => props.width};
  height: ${(props: { height?: any; }) => (props.height ? props.height : 'auto')};
`;

interface InputRowProps {
  id: string;
  labelText: string;
  children: React.ReactNode;
  inputFieldWidth: string;
  inputFieldHeight?: string;
}

const InputRow: React.FC<InputRowProps> = ({
  id,
  labelText,
  children,
  inputFieldWidth,
  inputFieldHeight,
}) => {
  return (
    <InputRowWrapper>
      <InputLabelWrapper>
        <Label htmlFor={id} text={labelText} />
      </InputLabelWrapper>
      <InputFieldWrapper width={inputFieldWidth} height={inputFieldHeight}>
        {children}
      </InputFieldWrapper>
    </InputRowWrapper>
  );
};

interface InputRowWithTextInputProps {
  name: string;
  labelText: string;
  inputValue?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const InputRowWithTextInput: React.FC<InputRowWithTextInputProps> = ({
  name,
  labelText,
  inputValue = '',
  onChange,
}) => (
    <InputRow id={`${name}Id`} labelText={labelText} inputFieldWidth="25%">
      <Input
        id={`${name}Id`}
        name={name}
        value={inputValue}
        onChange={onChange}
      />
    </InputRow>
  );

  interface InputRowWithEmailInputProps {
    id?: string;
    name: string;
    labelText: string;
    inputValue?: string;
    onChange: (value: string) => void;
    setDisplayMessage: (message?: Message) => void;
    displayMessage?: Message;
    domainList: string[];
    emailList: string[];
  }

  export const InputRowWithEmailInput: React.FC<InputRowWithEmailInputProps> = ({
    id,
    name,
    labelText,
    inputValue = '',
    onChange,
    setDisplayMessage,
    displayMessage,
    domainList,
    emailList,
  }) => (
    <InputRow id={id || name} labelText={labelText} inputFieldWidth="40%">
      <RegisteredEmailDomainInputContainer
        id={id || name}
        email={inputValue}
        setEmail={onChange}
        setDisplayMessage={setDisplayMessage}
        displayMessage={displayMessage}
        domainList={domainList}
        emailList={emailList}
      />
    </InputRow>
  );

  interface InputRowWithTextAreaProps {
    name: string;
    labelText: string;
    inputValue?: string;
    onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  }

  export const InputRowWithTextArea: React.FC<InputRowWithTextAreaProps> = ({
    name,
    labelText,
    inputValue = '',
    onChange,
  }) => (
    <InputRow
      id={`${name}Id`}
      labelText={labelText}
      inputFieldWidth="80%"
      inputFieldHeight="300px"
    >
      <TextArea
        id={`${name}Id`}
        name={name}
        value={inputValue}
        onChange={onChange}
      />
    </InputRow>
  );
